// This import loads the firebase namespace along with all its type information.
import Progress from './progress-model'

export async function load_progresss(): Promise<Progress[]> {
  throw 'Not implemented'
}

export async function delete_progress(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_progress(): Promise<Progress> {
  throw 'Not implemented'
}
